const list = [
  {
    id: 1,
    title:'运营托管模式解决方案',
    englishTitle:'Operational custody mode solution',
    desc:'许多中职校选择与第三方供应商合作进行校园网建设，而许多供应商由于运营管理不足,导致无力提供后续校园网运营服务，校园网后续如何运营成为校方亟需解决的难题。',
    img:'image/solution/detail.png',
    difficult: {
      difficultTitle: '困难与挑战',
      difficultSecondTitle: "Difficulties and challenges",
      difficultImageSrc: 'image/solution/detail-one1.png',
      difficult: [
        {title: "运营与困境", desc: "校园网运营效果不理想，供应商运维服务无积极性，学生用户无粘性，形成恶性循环；"},
        {title: "功能单一", desc: "校园网现有认证计费系统功能单一，学生用户购买意向不强；"},
        {title: "经验不足", desc: "供应商运营管理经验不足，用户转化率提升困难；"}
      ]
    },
    solutionTitle:"方案价值",
    solutionSecondTitle:"Value of the plan",
    products:[1,2,3],
    solutionSecondDesc:"网联拥有丰富的校园网运营管理经验，运营管理平台支持接入多种品牌、类型认证计费系统，帮助校园网供应商提高运营收益。",
    detail: [
      {
        title:"兼容性强",
        img:'image/solution/detail-one2.png',
        desc:'网联运营管理平台支持接入各类标准协议认证计费平台，同时支持定制接入部分非标准协议' +
          '认证计费平台。'
      },
      {
        title:"计费灵活",
        img:'image/solution/detail-one3.png',
        desc:'校园网套餐计费方式灵活，支持免费、代拨、付费+代拨方式，付费套餐支持按天数/速率/终' +
          '端数/买赠进行购买，能够有效提高学生用户购买意向；',
      },
      {
        title:"专业运营",
        img:'image/solution/detail-one4.png',
        desc:'拥有专业运营管理团队，项目当地团队会定期通过迎新、地推等方式提升校园网用户转换率；',
      },
    ]
  },
  {
    id: 2,
    title:'自运营模式解决方案',
    englishTitle:'Self operation mode solution',
    desc:'中职校校园网是校园信息化建设的重要支柱，但如何建造一张安全可靠、高效运营的校园网络成为目前许多中职校亟需解决的核心问题',
    img:'image/solution/detail-two-bg.png',
    difficult: {
      difficultTitle: '困难与挑战',
      difficultSecondTitle: "Difficulties and challenges",
      difficultImageSrc: 'image/solution/detail-two1.png',
      difficult: [
        {title: "资金不足", desc: "校方建设校园网资金不足，只能优先保障办公网的建设，学生宿舍以及公共区域校园网无多余资金建设"},
        {title: "运营风险", desc: "校方引入的第三方供应商建设校园网往往采购其他厂家设备，可能存在故障处理不及时、运营效果不理想等问题；"},
        {title: "数据割裂", desc: "学校自建办公网与供应商承建校园网数据割裂，造成网管运维不便捷、师生使用体验不佳的问题；"}
      ]
    },
    solutionTitle:"方案价值",
    solutionSecondTitle:"Value of the plan",
    products:[1,2,3],
    solutionSecondDesc:"网联研发团队具备完整强大的软硬件研发能力，拥有从硬件、平台及应用的完整自主研发产品体系，公司产品具有功能丰富、性能稳定、成本较低的优势",
    detail: [
      {
        title:"经验丰富",
        img:'image/solution/detail-self1.png',
        desc:'拥有十年中职学校校园网规、建、运、维经验，获得腾讯、广发信德、招商银科、分享投资、' +
          '中国风险投资有限公司、吉富创投等国内知名机构数亿元投资，于2016年新三板挂牌。',
      },
      {
        title:"技术自主性",
        img:'image/solution/detail-self2.png',
        desc:'自研从平台、设备到应用的全套产品，拥有专项项目经理与多种线上报障通道，能够及时处理' +
          '各类故障问题；'
      },
      {
        title:"一体化简化",
        img:'image/solution/detail-self3.png',
        desc:'提供校园有线无线一体化建设方案，简化网管运维难度，提升师生使用校园网体验；',
      },
      {
        title:"套餐灵活性",
        img:'image/solution/detail-self4.png',
        desc:'校园网套餐计费方式灵活，用户能够按照天数/速率/终端数自由选择套餐。',
      },
    ]
  },
  {
    id: 3,
    title:'以太网组网方案解决方案',
    englishTitle:'',
    desc:'学校在建设校园无线网络覆盖的同时完善校园有线网络，利用无线网络承载校园场景下用户设备联网需求，同时使整个无线网络具有可靠、安全、易管理、低延迟等特点',
    img:'image/solution/detail-three-bg.png',
    difficult: {
      difficultTitle: '困难与挑战',
      difficultSecondTitle: "Difficulties and challenges",
      difficultImageSrc: 'image/solution/detail-diffict3.png',
      difficult: [
        {title: "覆盖不足", desc: "高职校园无线网络无法做到全面覆盖，大部分学校只覆盖办公室与宿舍区域，师生使用无线网络不便捷；"},
        {title: "信息化滞后", desc: "传统的高职学校校园信息化建设普遍落后，设备老化、管理困难、维护成本高；"},
        {title: "网络数据孤岛", desc: "学校办公网与校园网数据割裂，造成网管运维不便捷、师生使用体验不佳的问题；"},
        {title: "网络权限管控", desc: "传统的无线网络无法做到对于上网人员的权限管控，而校园网需要一些技术方法对师生的上网行为管理，保障师生上网的体验，同时对于师生的上网行为进行管理，保证师生上网的正当言论。"}
      ]
    },
    solutionTitle:"方案价值",
    solutionSecondTitle:"Value of the plan",
    products:[1,2,3],
    solutionSecondDesc:"网联研发团队具备完整强大的软硬件研发能力，拥有从硬件、平台及应用的完整自主研发产品体系，公司产品具有功能丰富、性能稳定、成本较低的优势。",
    detail: [
      {
        title:"链路高可靠",
        img:'image/solution/solution-value-three1.png',
        desc:'汇聚交换机万兆上联，通过端口聚合技术进行双物理链路上联，打造高可靠性的万兆互联有线网络；',
      },
      {
        title:"全场景无线覆盖",
        img:'image/solution/solution-value-three2.png',
        desc:'根据校园内不同应用场景，使用不同类型无线AP进行覆盖，贴合用户实际使用场景；'
      },
      {
        title:"高性能无线AP",
        img:'image/solution/solution-value-three3.png',
        desc:'无线AP均支持WiFi6技术，有效满足校园无线网络用户多、流量大场景；',
      },
      {
        title:"有线无线一体化运维",
        img:'image/solution/solution-value-three4.png',
        desc:'校内网络有线无线一体化，交换机、无线AP、无线用户由平台统一管控；',
      },
      {
        title:"安全审计",
        img:'image/solution/solution-value-three5.png',
        desc:'全校用户上网行为可管可控、可审计，符合公安部82号令、151号令。',
      },
    ]
  },
  {
    id: 4,
    title:'工地员工宿舍无线网络解决方案',
    englishTitle:'',
    desc:'工地宿舍内员工在宿舍内进行在线安全学习、与家人视频通话、使用社交媒体或进行其他网络活动，因此，一套完整先进的宿舍无线网络能够提升工地人员管理效率、提高员工满意度',
    img:'image/solution/detail-four-bg.png',
    difficult: {
      difficultTitle: '困难与挑战',
      difficultSecondTitle: "Difficulties and challenges",
      difficultImageSrc: 'image/solution/detail-diffict4.png',
      difficult: [
        {title: "成本效益管理", desc: "对于许多工地而言，无线网络设备采购、安装和维护需要一定的成本投入，如何有效的进行成本控制是一个重要问题；"},
        {title: "网络覆盖不佳", desc: "工地员工宿舍存在布局复杂、无线网络信号覆盖效果差等问题，影响员工上网体验；"},
        {title: "网络运维挑战", desc: "人员流动性较高，无线网络认证和管理复杂，而工地基本无专业的网络运维人员对此进行管理；"},
        {title: "网络监管缺失", desc: "员工在宿舍上网无法被监管，存在网上发表不当言论等风险需要企业承担。"}
      ]
    },
    solutionTitle:"方案价值",
    solutionSecondTitle:"Value of the plan",
    products:[1,2,3],
    solutionSecondDesc:"网联为工地员工宿舍提供一体化的规划、建设、运营和运维服务，截至目前，网联已为上百所城市的上千万用户提供无线网络服务",
    detail: [
      {
        title:"规、建、营、维一体化服务",
        img:'image/solution/solution-value-four1.png',
        desc:'网联为工地提供规、建、营、维一体化服务，既能节省企业的成本支出，又能显著提升宿舍员工满意度；',
      },
      {
        title:"高品质无线网络",
        img:'image/solution/solution-value-four2.png',
        desc:'通过面板AP入室无线网络覆盖，为宿舍内提供高品质、全覆盖的无线网络上网体验；'
      },
      {
        title:"云平台统一运维管理",
        img:'image/solution/solution-value-four3.png',
        desc:'通过网联云运维管理平台，对宿舍内所有交换机、无线AP、无线用户统一运维管控，解决宿舍无线网络运维难问题；',
      },
      {
        title:"安全审计",
        img:'image/solution/solution-value-three5.png',
        desc:'全校用户上网行为可管可控、可审计，符合公安部82号令、151号令。',
      },
    ]
  },
  {
    id: 5,
    title:'全光网组网方案解决方案',
    englishTitle:'',
    desc:'现有的铜缆承载的无线网络已无法满足日益增长的用户需求，校园亟需建设一套高质量、高承载能力的有线、无线网络',
    img:'image/solution/detail-five-bg.png',
    difficult: {
      difficultTitle: '困难与挑战',
      difficultSecondTitle: "Difficulties and challenges",
      difficultImageSrc: 'image/solution/detail-diffict5.png',
      difficult: [
        {title: "网络基础设施限制", desc: "有线网络是整个信息社会的技术底座，但传统铜缆对信号存在着较大的衰减、以太网高速信号只能限制在100米以内，配套还需要增加弱电间(机房)、空调等设备；"},
        {title: "供电依赖性", desc: "光网AP通过光纤进行数据传输，但需通过AC电源方式进行供电，需要在AP部署位置额外部署强电线路，增加施工难度与成本；"},
        {title: "网络行为管理", desc: "传统的无线网络无法做到对于上网人员的权限进行管控，而校园网需要一些技术方法对师生的上网行为管理，保障师生上网的体验，同时对于师生的上网行为进行管理保证师生上网的正当言论；"},
      ]
    },
    solutionTitle:"方案价值",
    solutionSecondTitle:"Value of the plan",
    products:[1,2,3],
    solutionSecondDesc:"网联研发团队具备完整强大的软硬件研发能力，拥有从硬件、平台及应用的完整自主研发产品体系，公司产品具有功能丰富、性能稳定、成本较低的优势。",
    detail: [
      {
        title:"有线网络全光网",
        img:'image/solution/solution-value-five1.png',
        desc:'基础有线网络使用PON光网络组网，实现全校基础网络光网建设改造；',
      },
      {
        title:"光纤线路优势",
        img:'image/solution/solution-value-five2.png',
        desc:'光纤入室，既释放桥架桥架压力，又避免传统以太网线缆线路老化问题，光纤线路使用寿命长，维护成本低；'
      },
      {
        title:"全场景光AP覆盖",
        img:'image/solution/solution-value-five3.png',
        desc:'部署支持校园内各类型场景覆盖的光网AP，提供无处不在的高速上网体验 ；',
      },
      {
        title:"运营级高通WiFi解决方案",
        img:'image/solution/solution-value-five4.png',
        desc:'无线使用最新的高通WiFi6芯片方案，提供运营级的无线能力，高密高并发，高可靠；',
      },
      {
        title:"复合光缆供电",
        img:'image/solution/solution-value-five5.png',
        desc:'数据传输和供电一体化，供电更安全，光网AP供电无需单独部署强电线路；',
      },
      {
        title:"安全审计",
        img:'image/solution/solution-value-three5.png',
        desc:'全校用户上网行为可管可控、可审计，符合公安部82号令、151号令。',
      },
    ]
  },
  {
    id: 6,
    title:'工厂宿舍无线网络解决方案',
    englishTitle:'',
    desc:'工厂园区网络承载园区所有业务与应用，对工厂企业重要性不言而喻，因此，员工宿舍亟需一套完整先进的宿舍无线网络，保障员工有一个安全、快速、稳定的宿舍无线网络环境',
    img:'image/solution/detail-six-bg.png',
    difficult: {
      difficultTitle: '困难与挑战',
      difficultSecondTitle: "Difficulties and challenges",
      difficultImageSrc: 'image/solution/detail-diffict6.png',
      difficult: [
        {title: "网络覆盖限制", desc: "大多数工厂注重生产效益，只在车间及办公室覆盖无线网络，员工宿舍不覆盖或无资金预算覆盖无线网络；"},
        {title: "宿舍网络体验差", desc: "工厂宿舍无线网络覆盖效果差、用网卡顿，影响员工休息时上网体验；"},
        {title: "网络设施陈旧", desc: "员工宿舍普遍存在网络设备老化、管理困难、维护成本高等问题；"},
        {title: "网络行为风险", desc: "员工在宿舍上网无法被监管，存在网上发表不当言论等风险需要企业承担。"},
      ]
    },
    solutionTitle:"方案价值",
    solutionSecondTitle:"Value of the plan",
    products:[1,2,3],
    solutionSecondDesc:"网联为厂园生活区提供一体化的生活、娱乐、社交、健康、上网解决方案，既大大节省厂方的投资预算，又显著提升宿舍服务品质和员工满意度",
    detail: [
      {
        title:"高品质无线网络",
        img:'image/solution/solution-value-four2.png',
        desc:'通过面板AP入室无线网络覆盖，为宿舍内提供高品质、全覆盖的无线网络上网体验；',
      },
      {
        title:"云平台统一运维管理",
        img:'image/solution/solution-value-four3.png',
        desc:'通过网联云运维管理平台，对宿舍内所有交换机、无线AP、无线用户统一运维管控，解决宿舍无线网络运维难问题；'
      },
      {
        title:"智慧生活娱乐空间",
        img:'image/solution/solution-value-six3.png',
        desc:'提供自助洗衣机、自主娱乐等设备，丰富员工娱乐活动，提升员工满意度。',
      },
      {
        title:"安全审计",
        img:'image/solution/solution-value-three5.png',
        desc:'全校用户上网行为可管可控、可审计，符合公安部82号令、151号令。',
      },
    ]
  },
  {
    id: 7,
    title:'接入运营商AAA平台模式解决方案',
    englishTitle:'',
    desc:'目前，许多中职校校园网建设选择与第三方供应商联合建设，而供应商为了分担建设成本选择与运营商合作共建，由运营商提供出口宽带资源，供应商负责校内校园网建设。运营商在校内发展校园融合套餐业务，供应商的认证计费平台需对接到运营商的AAA平台',
    img:'image/solution/detail-seven-bg.png',
    difficult: {
      difficultTitle: '困难与挑战',
      difficultSecondTitle: "Difficulties and challenges",
      difficultImageSrc: 'image/solution/detail-diffict7.png',
      difficult: [
        {title: "经济成本高", desc: "供应商现有认证计费平台不支持对接运营商AAA平台，其他支持对接的主流品牌认证计费平台价格昂贵，导致供应商投入成本过高；"},
        {title: "对接成本高", desc: "主流品牌认证计费平台对接运营商AAA平台操作复杂，原厂技术支持服务收费昂贵，导致供应商人力成本、时间成本过高；"},
        {title: "办理效率低", desc: "主流品牌认证计费平台只支持对接运营商AAA平台，不支持对接运营商开户系统，学生用户购买融合套餐后，业务办理人员还需手动开通学生校园网账户，存在工作量大、业务办理效率低等问题；"},
      ]
    },
    solutionTitle:"方案价值",
    solutionSecondTitle:"Value of the plan",
    products:[1,2,3],
    solutionSecondDesc:"网联认证计费网关支持对接运营商AAA平台，拥有易操作、原厂技术免费对接等优势，目前已在多个省市与多家运营商AAA平台进行对接",
    detail: [
      {
        title:"自动开通效率",
        img:'image/solution/solution-value-seven1.png',
        desc:'同时支持对接运营商AAA平台与开户系统，学生在校园营业厅办理融合套餐时自动开通校园网账号，提升校园网业务办理效率。',
      },
      {
        title:"自助服务减负",
        img:'image/solution/solution-value-seven2.png',
        desc:'提供用户自助服务功能，学生用户能够进行自助查询、账号登出等操作，减少运维人员工作量；'
      },
    ]
  },
  {
    id: 8,
    title:'代拨模式解决方案',
    englishTitle:'',
    desc:'近年来，越来越多的中职校选择与运营商联合建设、运营校园网，校方需要运营商进行投建、运维校园网络，运营商也需要校园市场发展手机号卡、宽带业务，在这样的需求场景下，如何即保障校方权益又能使运营商更好的发展校园业务，成为中职校校园网建设与运营亟需解决的难题',
    img:'image/solution/detail-eight-bg.png',
    difficult: {
      difficultTitle: '困难与挑战',
      difficultSecondTitle: "Difficulties and challenges",
      difficultImageSrc: 'image/solution/detail-diffict8.png',
      difficult: [
        {title: "资金不足", desc: "校方建设校园网资金不足，运营商建设校园网资金有限，校园网建设覆盖效果不理想；"},
        {title: "分散管理", desc: "多家运营商建设多张校园网络，校方无法对校园网进行统一管控、运营；"},
        {title: "业务隔离", desc: "运营商手机号卡与校园宽带业务隔离，用户留存率低；"},
        {title: "用户体验差", desc: "运营商校园网账号复杂，学生使用校园网体验不佳；"},
      ]
    },
    solutionTitle:"方案价值",
    solutionSecondTitle:"Value of the plan",
    products:[1,2,3],
    solutionSecondDesc:"网联为中职学校提供校园网规、建、运和维一体化的智能无线网络方案及服务，解决中职校校园网建设与运营问题",
    detail: [
      {
        title:"自主研发优势",
        img:'image/solution/solution-value-eight1.png',
        desc:'拥有从硬件、平台再到应用的完整自主研发体系，在校园网项目投建上拥有软、硬件投建的成本优势。',
      },
      {
        title:"统一管理能力",
        img:'image/solution/solution-value-eight2.png',
        desc:'云运营管理平台支持对全网设备统一管理，全校用户统一管控，全部业务统一运营，提高校园网统一管控、运营能力。'
      },
      {
        title:"业务融合",
        img:'image/solution/solution-value-eight3.png',
        desc:'自研代拨网关设备支持多运营商接入，代拨模式将运营商号卡与宽带业务融合，融合两种业务目标群体，提高业务开通率与用户留存率。'
      },
      {
        title:"用户体验优化",
        img:'image/solution/solution-value-eight4.png',
        desc:'代拨网关将运营商宽带账号自动转换成学生手机号或者学号，提升学生使用校园网体验。'
      },
    ]
  },
  {
    id: 9,
    title:'一脸通的解决方案',
    englishTitle:'',
    desc:'智慧校园方案背景基于教育信息化2.0行动计划，方案关注智能化基础设施建设、信息化业务整合、安全保障，以及个性化、高效化教学需求，以实现校园管理与服务的智能化，推动教育现代化。',
    img:'image/solution/detail-night-bg.png',
    difficult: {
      difficultTitle: '困难与挑战',
      difficultSecondTitle: "Difficulties and challenges",
      difficultImageSrc: 'image/solution/detail-diffict9.png',
      difficult: [
        {title: "缺乏标准化模式", desc: "智慧校园建设没有统一的标准模式和路径，每所学校都需要根据自身特点进行个性化规划和建设。"},
        {title: "数据孤岛问题", desc: "由于历史原因，学校间资源无法共享，形成了数据孤岛、应用孤岛等问题，影响了资源的高效利用和教育质量的整体提升。"},
        {title: "安全隐私保护", desc: "随着大量教育数据的产生和使用，如何保护学生和教师的隐私，确保数据安全，成为一个重要挑战。"},
        {title: "用户接受度", desc: "推广智慧校园系统时，需要考虑到师生对新技术的接受度，以及必要的培训和支持，以确保系统的顺利使用和效果的最大化。"},
      ]
    },
    solutionTitle:"方案价值",
    solutionSecondTitle:"Value of the plan",
    products:[18,21,22],
    solutionSecondDesc:"智联研发团队具备完整强大的软硬件研发能力，拥有从硬件、平台及应用的完整自主研发产品体系，公司产品具有功能丰富、性能稳定、成本较低的优势",
    detail: [
      {
        title:"智慧校园数据互通",
        img:'image/solution/solution-value-night1.png',
        desc:'采用一脸/卡通平台架构，以实现智慧校园全场景下的所有子系统数据互通，解决了学校的数据孤岛问题，利用智慧校园的数据分析和管理功能，学校管理层可以更加高效地进行决策支持和日常管理。',
      },
      {
        title:"自主研发全套产品",
        img:'image/solution/solution-value-night2.png',
        desc:'自研从平台、设备到应用的全套产品，拥有专项项目经理与多种线上报障通道，能够及时处理各类故障问题；'
      },
      {
        title:"智慧校园一体化建设",
        img:'image/solution/solution-value-night3.png',
        desc:'提供智慧校园一体化建设方案，简化项目运维难度，提升师生使用智慧化校园体验；'
      },
      {
        title:"定制化开发响应",
        img:'image/solution/solution-value-night4.png',
        desc:'自研团队的优势在于可根据不同学校的不同需求，做快速响应的定制化开发，无需担心标准化产品带来顾此失彼的窘境；'
      },
    ]
  },
  ]

export default list



// WEBPACK FOOTER //
// ./src/pages/solution/detailData.js